import React from 'react'
import { ViewListprofile } from './ViewListprofile'
import { Modal, ModalHeader } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalViewProfiles = (props) => {

    const {

        modal, toggle, modalTitle, method, listProfile
    } = props;

    return (

        <Dialog
            header={modalTitle}
            visible={modal}
            onHide={toggle}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}            modal
            closable
            dismissableMask={false} 
            blockScroll  
            className="small-dialog"
        >
            {
                method === "list"
                ?
                    <ViewListprofile
                        { ...{toggle, listProfile} }
                    />
                :
                ""
            }

            
        </Dialog>
      
    )
}
